import * as React from "react";
import {TextInput} from "./TextInput";
import {ErlButtonBig} from "./ErlButtonBig";
import './payment.css';
import {InputFieldState} from "../../shared/helpers/InputFieldState";

interface PaymentReservationPinState {
    pin: InputFieldState,
    fetchRunning: boolean,
    success: boolean,
    paymentUrl: string,
    downloadUrl: string,
    status: string,
    downloaded: boolean
}

interface PaymentReservationPinProps {
    status: string,
    downloadUrl: string,
}

export enum PaymentStatus {
    StatusOpen = 'open',
    StatusPending = 'pending',
    StatusReceived = 'received',
    StatusRefunded = 'refunded',
    StatusLoss = 'loss',
    StatusFailure = 'failure',
}

/**
 * Text Input Element
 */
export class PaymentReservationPin extends React.Component<PaymentReservationPinProps, PaymentReservationPinState> {

    state: PaymentReservationPinState;

    apiHeaders: any;

    constructor(props: any) {
        super(props);

        this.state = {
            pin: {value: ''},
            fetchRunning: false,
            success: false,
            paymentUrl: undefined,
            downloadUrl: this.props.downloadUrl,
            status: this.props.status,
            downloaded: false
        };

        this.apiHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

    }

    /**
     * send pin to backend and check already paid.
     */
    sendPin() {
        if (this.state.fetchRunning) {
            return;
        }

        this.setState({fetchRunning: true});

        fetch('/wp-json/erl-api/v1/payment/reservation/pin', {
            method: 'POST',
            headers: this.apiHeaders,
            body: JSON.stringify({
                pin: parseInt(this.state.pin.value + '', 10)
            })
        })
            .then(res => res.json())
            .then((data) => {
                if (data.success) {
                    // set payment reservation status
                    this.setState({
                        success: true,
                        paymentUrl: data.redirectUrl,
                        downloadUrl: data.downloadUrl,
                        status: data.status,
                    });
                } else {
                    // error handling
                    const pin = this.state.pin;
                    pin.errorMessage = data.error;
                    this.setState({
                        fetchRunning: false,
                        pin: pin,
                    });
                }
            }).catch(() => {
            this.setState({fetchRunning: false});
        });
    }

    render() {
        let divClass = '';
        if (PaymentStatus.StatusReceived === this.state.status) {
            divClass = 'payment-reservation-pin-paid';
        } else if (this.state.success) {
            divClass = 'payment-reservation-pin-not-paid';
        }

        return <div className={"payment-reservation-pin"}>
            <div className={divClass}>
                {PaymentStatus.StatusReceived === this.state.status ? (
                    <div>
                        {!this.state.downloaded ? (
                            <div>
                                <h4>Wir haben Ihre Reservierungsgebühr erhalten</h4>
                                <div className="spacer-20"></div>
                                <p>Herzlichen Glückwunsch. Ihrem Kauf steht jetzt nichts mehr im Wege.</p>
                                <p>Sie können sich jetzt über nachfolgenden Button den aktualisierten Kaufauftrag
                                    herunterladen.</p>
                                <ErlButtonBig label="Kaufauftrag herunterladen"
                                              onclick={() => {
                                                  this.setState({
                                                      downloaded: true
                                                  });
                                                  window.open(this.state.downloadUrl);
                                              }}/>
                            </div>
                        ) : (
                            <div>
                                <h4>Vorgang abgeschlossen</h4>
                                <div className="spacer-20"></div>
                                <p>Herzlichen Glückwunsch. Ihrem Kauf steht jetzt nichts mehr im Wege.</p>
                                <p>Wir bedanken uns für Ihr Vertrauen und freuen uns, Sie als neuen Kunden begrüßen
                                    zu dürfen</p>
                                <p>Ihre Familie Erl</p>
                            </div>
                        )}
                    </div>
                ) : (
                    <div>
                        {!this.state.success ? (
                            <div>
                                <TextInput darkMode={false} label="PIN *" state={this.state.pin} onChange={value => {
                                    this.setState({pin: {value: value}});
                                }} onEnter={this.sendPin.bind(this)}/>
                                <ErlButtonBig label="Einloggen" onclick={this.sendPin.bind(this)}/>
                                {PaymentStatus.StatusFailure === this.state.status && (
                                    <div>
                                        <div className="spacer-20"></div>
                                        <div className="error_message">Zahlung fehlgeschlagen</div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div>
                                <div>
                                    <h4>Finanzierung geklärt, Kaufentscheidung getroffen.</h4>
                                    <h4>Wir freuen uns, Sie als neuen Kunden begrüßen zu dürfen.</h4>
                                    <div className="spacer-20"></div>
                                    <div>
                                        Ihre Zahlung der Reservierungsgebühr ist noch offen.
                                    </div>
                                    <div className="spacer-20"></div>
                                    <div>
                                        <ErlButtonBig label="Jetzt Zahlung durchführen"
                                                      onclick={() => window.location.href = this.state.paymentUrl}/>
                                    </div>
                                    <div className="spacer-20"></div>
                                    <div>
                                        <p>
                                            Mit Anzahlung der Reservierungsgebühr erhalten Sie von uns eine
                                            Bestätigung der Reservierung und es folgt die notarielle Kaufabwicklung.
                                        </p>
                                        <p>
                                            Die Reservierungsgebühr muss in dem auf dem Kaufvertrag angegebenen Zeitraum
                                            beglichen werden, andernfalls wird die Reservierung wieder
                                            aufgehoben.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    }
}
